// extracted by mini-css-extract-plugin
export var root = "Breadcrumbs-root-GM8xZ";
export var rootArticle = "Breadcrumbs-root-article-46tlZ";
export var rootIcon = "Breadcrumbs-root_icon-0Fhab";
export var rootItem = "Breadcrumbs-root_item-UEOlm";
export var rootLink = "Breadcrumbs-root_link-RYP6o";
export var rootSpan = "Breadcrumbs-root_span-SJ6P-";